<template>
   <div class="choose-cinema-wrapper">
    <!-- top返回 -->
      <MovieGoBack :text="text"></MovieGoBack>
      
      <!-- 卡片 -->
        <div class="movie-box acea-row movie-detail-card">
            <img src="https://img.daeyes.com.cn:8081/uploads/images/Film/4377fab5-f81d-42ec-b001-73135da9dd33/20210208090807.jpg"/>
            <div class="detail">
                <div class="h page-text-ellipsis-nowrap">你好，李焕英</div>
                <p>奇幻/动作/冒险</p>
                <p>120分钟</p>
                <div class="time page-text-center">2021-02-12</div>
                <p class="score">评分：9.3</p>
            </div>
       </div>

    <!-- 选择时间 -->
   <ul class="movie-horizontal-scroll-bar time-wrapper">
       <li v-for='(item, ind) in timeList' 
          :key='ind'
          @click='clickTime(item)'
          :class='{checkedLi:item.checked}'
          >{{item.title}}</li>
   </ul>

   <!-- 筛选项 -->
   <div class="screen-wrapper">
       筛选▼
   </div>

    <!-- 影院数据 -->
    <div class="cinemas-wrapper">

        <!-- 单个模板 -->
        <router-link
           v-for="(item,ind) in data" :key='ind' :to="'/cinemasDetails'"
           >
           <div class="cinemas-data">
            <!-- 电影标题 -->
              <div class="acea-row row-between row-middle title-and-price">
                <div class="page-text-ellipsis-nowrap title">{{item.name}}</div>
                <div class="price"><span>{{item.lowPrice}}</span>元起</div>
              </div>
              <!-- 地址距离 -->
              <div class="acea-row row-between row-middle address-wrapper">
                <div class="page-text-ellipsis-nowrap address">{{item.address}}</div>
                <div class="distance">>{{item.distance}}km</div>
              </div>
              <!-- 标签 -->
              <ul class="acea-row features">
                  <li v-for="(val,key) in item.features" :key="key">{{val.name}}</li>
              </ul>
            </div>
        </router-link>
    </div>

   </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";

export default {
    name:"ChooseCinema",
    components:{
        MovieGoBack
    },
    data:function(){
        return{
            text:'你好，李焕英',
            timeList:[
                {
                    title:'今天(03.23周二)',
                    checked:true
                },{
                    title:'明天(03.24周三)',
                    checked:false
                },{
                    title:'后天(03.25周四)',
                    checked:false
                },{
                    title:'03.26周五',
                    checked:false
                },{
                    title:'03.27周六',
                    checked:false
                },{
                    title:'03.28周日',
                    checked:false
                }
            ],
            data:[
                {
                    address: "里水镇和顺大道8号万福城购物广场4楼",
                    cityId: 5,
                    distance: 187,
                    districtId: 63,
                    features: [
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"},
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"}
                    ],
                    id: 106367,
                    lowPrice: 35.5,
                    name: "星辉影城（和顺店）",
                    card:"开卡特惠 最高立减20元",
                    discount:"《你好，李焕英》等7部电影特惠"
                }, {
                    address: "里水镇和顺大道8号万福城购物广场4楼",
                    cityId: 5,
                    distance: 187,
                    districtId: 63,
                    features: [
                    {name: "自费购买", desc: "5-15元/副"},
                    {name: "可停车", desc: "商场停车场3小时内免费停车"},
                    {name: "儿童票", desc: "1.3米以下儿童免票观看电影但无座，1名家长仅可以带1名儿童。儿童有座半价观影。"},
                    {name: "有WIFI", desc: "提供免费WIFI"}],
                    id: 106367,
                    lowPrice: 35.5,
                    name: "星辉影城（和顺店）",
                    card:"开卡特惠 最高立减20元",
                    discount:"《你好，李焕英》等7部电影特惠"
                }
            ]
        }
    },
    mounted:function(){},
    methods:{
        clickTime:function(val){
            this.timeList.forEach((item,ind) => {
                item.checked = false;
            });
            val.checked = true;
        }
    }
}
</script>

<style scoped>

.movie-detail-card{
    height:2.9rem;
    padding:.2rem .3rem;
}

.movie-detail-card img{
    width:1.91rem;
    height:2.37rem;
    box-shadow: 0px 4px 9px 0px rgba(255, 12, 70, 0.29);
    border-radius:.15rem;
    flex-shrink: 0;
}
.detail{
    flex:1;
    margin-left:.34rem;
    overflow:hidden;
}
.detail .h{
    width:100%;
    font-size:.4rem;
    font-weight: 500;
    color: #333333;
    line-height: .8rem;
}
.detail p{
    font-size:.27rem;
    color: #666666;
    padding-bottom:.05rem;
}
.detail .time{
    width:1.7rem;
    height:.3rem;
    background:#00A0E9;
    border-radius:.16rem;
    line-height:.37rem;
    color:#ffff;
    font-size:.25rem;
    margin-bottom:.05rem;
}
.detail .score{
    font-weight: 500;
    color: #FF0C46;
    font-size:.3rem;
}

.title-and-price{
    margin-bottom:.3rem;
}
.address{
    font-size:.24rem;
    color:#8E8E8E;
    flex:1;
}
.distance{
    color: #999999;
    font-size:.18rem;
}
.features{
    margin:.1rem 0 0;
}
.features li{
    margin:0 .13rem .1rem 0;
    border-radius:.05rem;
    background: linear-gradient(-90deg, #8F7AD3 0%, #A5BDD6 100%);
    color: #FFFFFF;
    font-size:.22rem;
    padding: .02rem .1rem;
    flex-shrink: 0;
}

.title{
    font-size:.32rem;
    color: #333333;
    font-family: SourceHanSansCN;
    flex:1;
}
.price{
    color: #FF1048;
    font-size:.25rem;
    flex-shrink: 0;
}
.price span{
    font-size:.32rem;
}

/*  */

.time-wrapper{
    border-bottom:.01rem solid #ddd;
}
.time-wrapper li{
    box-sizing:border-box;
    padding:.26rem;
    color:rgb(51, 51, 51);
    display:inline-block;
}
.time-wrapper .checkedLi{
    color:rgba(255, 16, 72, 1);
    border-bottom:.02rem solid rgba(255, 16, 72, 1);
    font-weight: bold;
}
.screen-wrapper{
    height:.75rem;
    background:pink;
}

.cinemas-wrapper{
    width:100%;
    overflow:hidden;
    padding:.1rem .3rem;
}
.cinemas-data{
    width:100%;
    min-height:2rem;
    overflow:hidden;
    border-radius: .15rem;
    background: #FFFFFF;
    box-shadow: 0px 5px 21px 0px rgba(64, 64, 64, 0.14);
    margin-bottom:.2rem;
    padding:.17rem;
}

</style>